// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".VerticalMenuCard{background-color:#f4f4f4;border:initial;padding:1.375rem 1.25rem}.VerticalMenuCard__header{background-color:transparent!important;color:#606060;font-size:1rem;font-weight:700;line-height:1.75rem;margin-bottom:1rem;padding:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
